import script from "./AuthCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthCode.vue?vue&type=script&lang=ts&setup=true"

import "./AuthCode.vue?vue&type=style&index=0&id=eaddc2e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaddc2e6"]])

export default __exports__